import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-modal-mensaje-confirmacion',
  templateUrl: './modal-mensaje-confirmacion.component.html',
  styleUrls: ['./modal-mensaje-confirmacion.component.css']
})
export class ModalMensajeConfirmacionComponent implements OnInit {
  @Input() titulo
  @Input() mensaje

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
    
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/modal/modal-mensaje-confirmacion/modal-mensaje-confirmacion.component.ts